import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { startCreateTicket } from '../../actions/tickets';
import { startSetProfile } from '../../actions/webmaster';
import { startSetOffer, resetOffer } from '../../actions/offers';
import Card from '../../components/Card/Card';
import TicketForm from '../../components/Tickets/TicketForm';
import WithAlert from '../../hoc/WithAlert';
import { iFMessage } from '../../hoc/IntlComponents';
import omit from 'lodash/omit';
import { debounce } from '../../utils/utils';
import { faq } from '../../services/ApiService';
import { Helmet } from 'react-helmet';

const defaultFAQResults = (intl) => [
  {
    preview: '',
    title: intl.formatMessage({
      id: 'tickets.faq-defaults.1',
      defaultMessage: 'FAQ - frequently asked questions',
    }),
    // title: 'FAQ - часто задаваемые вопросы',
    path: 'faq/hello/novice',
  },
  {
    preview: '',
    title: intl.formatMessage({
      id: 'tickets.faq-defaults.2',
      defaultMessage: '3 simple steps to get started',
    }),
    // title: '3 простых шага для начала работы',
    path: 'faq/hello/sites',
  },
];

class CreateTicketPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offerId: this.getOfferId(),
      theme: this.getTheme(),
      results: defaultFAQResults(this.props.intl),
    };
  }

  componentDidMount() {
    const { offerId } = this.state;

    if (offerId) {
      this.props.startSetOffer(offerId);
    }
  }

  componentWillUnmount() {
    this.props.resetOffer();
  }

  getOfferId = () => {
    const { location } = this.props;
    const offerId = parseInt(parse(location.search).offer, 10);
    return !isNaN(offerId) ? offerId : null;
  };

  getTheme = () => {
    const { location } = this.props;
    const theme = parse(location.search).theme;
    return theme;
  };

  submit = (data) => {
    const { history, startSetProfile, startCreateTicket, showAlert, intl } = this.props;

    let message = '';

    const theme = this.getTheme();
    const formData = new FormData();

    const params =
      theme === 'masterAccount' ? { ...data, masterAccount: 1 } : omit(data, 'masterAccount');

    Object.keys(params).forEach((paramName) => {
      if (Array.isArray(params[paramName])) {
        for (let i in params[paramName]) {
          formData.append([paramName], params[paramName][i]);
        }
      } else {
        formData.append([paramName], params[paramName]);
      }
    });

    const postRequestActions =
      theme === 'masterAccount'
        ? () => startSetProfile().finally(() => history.push('/tools/master'))
        : () => history.push('/tickets');

    startCreateTicket(formData)
      .then(postRequestActions)
      .catch(({ response = {} }) => {
        if (response?.data?.error?.message?.message) {
          const { message: error } = response.data.error;
          message = error.message;
        } else {
          message = iFMessage({ intl, id: 'main.error' });
        }
        showAlert({
          message,
          alertType: 'danger',
          closeInSeconds: 5,
        });
        return message;
      });
  };

  onChange = (e) => {
    const { target } = e;

    if (target.name === 'text') {
      this.handleFaqSearch(target.value);
    }

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  handleFaqSearch = (query) => {
    if (query.length > 3 && query.length <= 15) {
      this.faqSearch(query);
    } else {
      this.setState({ results: defaultFAQResults(this.props.intl) });
    }
  };

  faqSearch = debounce((q) => {
    faq.search({ q }).then(({ items: results = [] }) => {
      !!results.length &&
        this.setState(() => ({
          results,
        }));
    });
  }, 500);

  render() {
    const { offer, history } = this.props;
    const { theme, offerId, results } = this.state;

    return (
      <>
        <Helmet title="Создать тикет" />
        <div className="tickets-create-page">
          <Breadcrumb className="mb-3">
            <BreadcrumbItem>
              <Link to="/tickets/">
                <FormattedMessage id="tickets.all_tickets" defaultMessage="All tickets" />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
            </BreadcrumbItem>
          </Breadcrumb>
          <div className="tickets-create-page-wrapper">
            <Card>
              <Card.Body>
                <h2 className="tickets-create-title">
                  <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
                </h2>
                {theme !== 'highLevelAccessRequest' && (
                  <p className="tickets-create-help">
                    <FormattedMessage
                      id="tickets.perhaps_answer"
                      defaultMessage="Perhaps the answer to your question is already in the"
                    />{' '}
                    &nbsp;
                    <Link to="/faq/">
                      <FormattedMessage
                        id="tickets.link_help_section"
                        defaultMessage="help section"
                      />
                    </Link>
                  </p>
                )}

                <TicketForm
                  offer={offer}
                  offerId={offerId}
                  theme={theme}
                  submit={this.submit}
                  history={history}
                  onChange={this.onChange}
                  formData={this.state.data}
                />

                <div className="tickets-create-page-hints"></div>
              </Card.Body>
            </Card>
            {!!results.length && (
              <Card>
                <Card.Body className="faq-search-result-container">
                  <h3 className="faq-search-result-title">
                    <FormattedMessage id="tickets.tips" defaultMessage="Tips" />
                  </h3>
                  {results.map(({ title, path, preview }) => (
                    <a
                      target="_blank"
                      href={'/' + path}
                      className="faq-search-result-item"
                      key={title}
                    >
                      <h3>{title}</h3>
                      <p className="faq-search-result-more">Подробнее</p>
                    </a>
                  ))}
                </Card.Body>
              </Card>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ offers }) => ({
  offer: offers.selected,
});

const mapDispatchToProps = (dispatch) => ({
  startCreateTicket: (ticketData) => dispatch(startCreateTicket(ticketData)),
  startSetOffer: (offerId) => dispatch(startSetOffer(offerId)),
  resetOffer: () => dispatch(resetOffer()),
  startSetProfile: () => dispatch(startSetProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(CreateTicketPage)));
